namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;
	import ps = Portico.Services;

	export interface IPorticoService {
		$log: angular.ILogService,
		authenticationService: ps.IAuthenticationService;
		authorizationService: ps.IAuthorizationService;
		couponService: ps.ICouponService,
		dataService: ps.IDataService;
		demoService: ps.IDemoService;
		enterpriseService: ps.IEnterpriseService;
		legacyService: ps.Legacy.IPorticoLegacyService;
		modalService: ps.IModalService;
		toastrService: ps.IToastrService;
		setupService: ps.ISetupService;
		pdfService: ps.IPdfService;
		sessionService: ps.ISessionService;
		sessionDetailService: ps.ISessionDetailService;
		storageService: ps.IStorageService;
		serverConstants: pm.Interfaces.IServerConstants;

		// data initialization functions
		/** @deprecated */
		initDataTables(): void;
		/** @deprecated */
		initDataTypes(): void;
		/** @deprecated */
		initDemos(): void;
		/** @deprecated */
		initDiagnoses(): void;
		/** @deprecated */
		initIntakeLayout(params?: string): void;
		/** @deprecated */
		initLayoutSection(): void;
		/** @deprecated */
		initNdcs(): void;
		/** @deprecated */
		initPortal(): void;
		/** @deprecated */
		initStates(key?: string): void;
		/** @deprecated */
		initSurveys(key?: string): void;
		/** @deprecated */
		initTemplates(): void;
		refresh(key: string): void;

		// data manipulation functions
		copy(source: any, target: any): void;

		// state transition functions
		page(name: string, options?: any): void;
		section(name: string, options?: any): void;
		state(app: string, layout: string, page: string, intake?: string, section?: string, options?: any): void;

		// account functions
		account_surveySession_get(account: pme.Account, survey: number | string): pme.SurveySession;
		account_surveySession_answer_get(account: pme.Account, survey: number | string, question: number | string): pme.SurveySessionAnswer;
		account_surveySession_answer_getValue(account: pme.Account, survey: number | string, question: number | string): string;
		account_surveySession_answers_get(account: pme.Account, survey: number | string, question: number | string): pme.SurveySessionAnswer[];
		account_surveySession_answers_getValues(account: pme.Account, surveyKey: number | string, questionKey: number | string): string[];
		account_surveySession_answers_set(account: pme.Account, survey: number | string, question: number | string, answers: (number | string)[], value: string): void;
		account_surveySession_answers_test(account: pme.Account, survey: number | string, question: number | string, answer: number | string): boolean;

		// document functions
		document_createPdfFromAccount(account: pme.Account): angular.IPromise<any>;

		// email functions
		email_feedback(feedbackRequest: pme.FeedbackRequest): angular.IPromise<boolean>;

		// intakeLayout functions
		intakeLayout_get(key?: number | string): angular.IPromise<pme.IntakeLayout>;
		intakeLayout_layoutSection_get(intakeLayout: pme.IntakeLayout, name: string): angular.IPromise<pme.LayoutSection>;
		intakeLayout_survey_populate(intakeLayout: pme.IntakeLayout): angular.IPromise<boolean>;

		// location functions
		location_states_get(key?: string): angular.IPromise<pme.State[]>;

		// survey functions
		survey_get(key: number | string): angular.IPromise<pme.Survey>;

		// dom manipulation functions
		color(hex: string, percent?: number): string;
		elementShow(id: string, show: boolean): void;
	}

	// temporarily renamed portico service; created data service to avoid circular injection issues
	@Service('app', 'porticoService')
	@Inject('$log', '$q', '$rootScope', '$state', 'Upload', 'authenticationService', 'authorizationService', 'couponService', 'dataService', 'demoService', 'enterpriseService', 'modalService', 'toastrService',
		'serverConstants', 'setupService', 'porticoLegacyService', 'errorService', 'spinnerOverrideService',
		'pdfService', 'storageService', 'sessionService', 'sessionDetailService')
	export class PorticoService implements IPorticoService {

		private serviceName: string = 'Portico.Services.Legacy.LegacyService';

		constructor(
			public $log: angular.ILogService,
			private $q: angular.IQService,
			private $rootScope: angular.IRootScopeService,
			private $state: angular.ui.IStateService,
			private $upload: any,
			public authenticationService: ps.IAuthenticationService,
			public authorizationService: ps.IAuthorizationService,
			public couponService: ps.ICouponService,
			public dataService: ps.IDataService,
			public demoService: ps.IDemoService,
			public enterpriseService: ps.IEnterpriseService,
			public modalService: ps.IModalService,
			public toastrService: ps.IToastrService,
			public serverConstants: pmi.IServerConstants,
			public setupService: ps.ISetupService,
			public legacyService: ps.Legacy.IPorticoLegacyService,
			public errorService: ps.ErrorService,
			public spinnerOverrideService: ps.ISpinnerOverrideService,
			public pdfService: ps.IPdfService,
			public storageService: ps.IStorageService,
			public sessionService: ps.ISessionService,
			public sessionDetailService: ps.ISessionDetailService
		) { }


		///////////////////////////////////
		// data initialization functions //
		///////////////////////////////////

		/** @deprecated */
		initDataTables() {
			return this.setupService.dataTableService.get().then((dataTables) => {
				this.dataService.setup.dataTables = dataTables;
				return true;
			});
		}

		/** @deprecated */
		initDataTypes() {
			return this.setupService.dataTypeService.get().then((dataTypes) => {
				this.dataService.setup.dataTypes = dataTypes;
				return true;
			});
		}

		/** @deprecated */
		initDemos() {
			return this.setupService.portalService.getByPortalGroupId(pm.PORTAL_GROUP_DEMO).then((portals) => {
				this.dataService.setup.demos = portals;
				return true;
			});
		}

		/** @deprecated */
		initDiagnoses() {
			return this.enterpriseService.diagnosisService.getByProgramId().then((diagnoses) => {
				this.dataService.enterprise.diagnoses = diagnoses;
				return true;
			});
		}

		/** @deprecated */
		initIntakeLayout(key: string = null) {
			if (key) {
				let json = this.dataService.getDataValue('Reference', 'Id', key);
				let intakeLayout = angular.fromJson(json);
				this.dataService.enterprise.intakeLayout = new pme.IntakeLayout(<pme.IIntakeLayout>intakeLayout);
			} else {
				const intake = this.dataService.state.intake;
				const intakeLayoutId = this.dataService.getEnvironmentId(`intake-${intake}`);
				const programId = this.dataService.getProgramId();

				return this.enterpriseService.intakeService.getIntakeLayout(programId, intakeLayoutId).then((intakeLayout: pme.IntakeLayout) => {
					this.dataService.enterprise.intakeLayout = intakeLayout;
					return true;
				});
			}

		}

		/** @deprecated */
		initLayoutSection() {
			const section = this.dataService.state.section;
			const intakeLayout = this.dataService.enterprise.intakeLayout;
			const layoutSection = intakeLayout.getLayoutSection(section);

			this.dataService.enterprise.layoutSection = layoutSection;

			return true;
		}

		/** @deprecated */
		initNdcs() {
			const programId = this.dataService.getProgramId();

			return this.enterpriseService.prescriptionService.getNdcList(programId).then((ndcs) => {
				this.dataService.enterprise.ndcs = ndcs;
				return true;
			});
		}

		/** @deprecated */
		initPortal() {
			const portalId = this.serverConstants.portalId;

			return this.setupService.portalService.getDetailsById(portalId).then((portal) => {
				this.dataService.setup.portal = portal;
				return true;
			});
		}

		/** @deprecated */
		initStates(key: string) {
			if (key) {
				let json = this.dataService.getDataValue('Reference', 'Id', key);
				let states: pme.State[] = angular.fromJson(json);
				this.dataService.enterprise.states = states;
			} else {
				return this.enterpriseService.locationService.getStates().then((states) => {
					this.dataService.enterprise.states = states;
					return true;
				});
			}
		}

		/** @deprecated */
		initSurveys(key: string) {
			if (key) {
				const json = this.dataService.getReferenceValue(key);
				const survey = angular.fromJson(json);

				this.dataService.enterprise.intakeLayout = new pme.IntakeLayout(<pme.IIntakeLayout>{
					surveys: [survey]
				});

				return this.$q.when(true);
			} else {
				const intakeLayout = this.dataService.enterprise.intakeLayout;
				const surveyPromises = [];

				intakeLayout.surveyIds.forEach((sid: number | string) => {
					const id = this.dataService.getEnvironmentId(sid);
					surveyPromises.push(this.enterpriseService.surveyService.get(id));
				});

				return this.$q.all(surveyPromises).then((surveys: pme.Survey[]) => {
					intakeLayout.surveys = surveys;
					return true;
				});
			}
		}

		/** @deprecated */
		initTemplates() {
			return this.setupService.dataGroupService.getByDataGroupTypeId(pm.DATA_GROUP_TYPE_TEMPLATE).then((dataGroups) => {
				this.dataService.setup.templates = dataGroups;
				return true;
			});
		}

		refresh(key: string): void {
			this.$rootScope.$broadcast(`tc-refresh-${key}`);
		}

		/////////////////////////////////
		// data manipulation functions //
		/////////////////////////////////	

		copy(source: any, target: any): void {
			angular.copy(source, target);
		}

		////////////////////////////////
		// state transition functions //
		////////////////////////////////

		page(name: string, options: any = null) {
			this.state(null, null, name, null, null, options);
		}

		section(name: string, options: any = null) {
			this.state(null, null, null, null, name, options);
		}

		state(app: string, layout: string, page: string, intake: string = null, section: string = null, options: any = null) {
			let name: string = 'app.layout.page';
			let params: any = options ? options : {};

			params.app = app ? app : this.dataService.state.app;
			params.layout = layout ? layout : this.dataService.state.layout;
			params.page = page ? page : this.dataService.state.page;

			if (section) {
				name += '.intake.section';
				params.intake = intake ? intake : this.dataService.state.intake;
				params.section = section ? section : this.dataService.state.section;

				const intakeLayout = this.dataService.enterprise.intakeLayout;

				if (intakeLayout) {
					const layoutSection = intakeLayout.getLayoutSection(params.section, this.dataService.state.section);

					if (layoutSection) {
						params.section = layoutSection.name;
					}
				}
			}

			if (angular.isUndefined(params.ppid)) { params.ppid = null; }
			if (angular.isUndefined(params.psid)) { params.psid = null; }
			if (angular.isUndefined(params.spid)) { params.spid = null; }
			if (angular.isUndefined(params.ssid)) { params.ssid = null; }
			if (angular.isUndefined(params.r2p)) { params.r2p = null; }
			if (angular.isUndefined(params.r2s)) { params.r2s = null; }

			this.$state.go(name, params);
		}



		///////////////////////
		// account functions //
		///////////////////////

		account_surveySession_get(account: pme.Account, survey: number | string): pme.SurveySession {
			const surveyId = this.dataService.getEnvironmentId(survey);
			return account ? account.getSurveySession(surveyId) : null;
		}

		account_surveySession_answer_get(account: pme.Account, survey: number | string, question: number | string): pme.SurveySessionAnswer {
			const answers = this.account_surveySession_answers_get(account, survey, question);
			return answers && answers.length > 0 ? answers[0] : null;
		}

		account_surveySession_answer_getValue(account: pme.Account, survey: number | string, question: number | string): string {
			const values = this.account_surveySession_answers_getValues(account, survey, question);
			return values && values.length > 0 ? values[0] : '';
		}

		account_surveySession_answers_get(account: pme.Account, survey: number | string, question: number | string): pme.SurveySessionAnswer[] {
			const surveySession = this.account_surveySession_get(account, survey);
			const questionId = this.dataService.getEnvironmentId(question);

			return surveySession ? surveySession.getSurveySessionAnswers(questionId) : null;
		}

		account_surveySession_answers_getValues(account: pme.Account, surveyKey: number | string, questionKey: number | string): string[] {
			const surveyId = this.dataService.getEnvironmentId(surveyKey);
			const survey: pme.Survey = _.find(this.dataService.enterprise.intakeLayout.surveys, (s) => { return s.surveyId === surveyId; });
			const surveySession = this.account_surveySession_get(account, surveyId);
			const questionId = this.dataService.getEnvironmentId(questionKey);
			const answers = surveySession ? surveySession.getSurveySessionAnswers(questionId) : [];

			return answers.map((answer) => {
				let answerValue = answer.answerValue;

				if (!answerValue) {
					const temp = survey.getSurveyAnswer(answer.questionId, answer.answerId);

					if (temp) {
						answerValue = temp.answerValue;
					}
				}

				return answerValue;
			});
		}

		account_surveySession_answers_set(account: pme.Account, survey: number | string, question: number | string, answers: (number | string)[], value: string): void {
			const surveyId = this.dataService.getEnvironmentId(survey);
			const surveySession = account.getSurveySession(surveyId);
			const questionId = this.dataService.getEnvironmentId(question);
			const answerIds = answers.map((answer) => {
				return this.dataService.getEnvironmentId(answer);
			});

			if (surveySession) {
				surveySession.setSurveySessionAnswers(questionId, answerIds, value);
			}
		}

		// Sets the type(s) of program for which member numbers should be generated (medical, pharmacy, hub)
		account_surveySession_answers_setProgramType(account: pme.Account, programType: string): void {
			const cardTypes = JSON.parse(this.dataService.getEnvironmentValue(programType + '-card-types'));
			this.account_surveySession_answers_set(account, 'survey-' + programType, 'survey-' + programType + '-card-type', cardTypes, null);
		}

		account_surveySession_answers_test(account: pme.Account, survey: number | string, question: number | string, answer: number | string): boolean {
			const surveySession = this.account_surveySession_get(account, survey);
			const questionId = this.dataService.getEnvironmentId(question);
			const answerId = this.dataService.getEnvironmentId(answer);

			return surveySession ? surveySession.isSurveySessionAnswer(questionId, answerId) : null;
		}

		////////////////////////
		// document functions //
		////////////////////////

		document_createPdfFromAccount(account: pme.Account): angular.IPromise<any> {
			const now = new Date().toJSON();
			const documentData: { [key: string]: string } = {};
			const documentName = now + '.pdf';
			const portalName = this.dataService.setup.portal.name;

			documentData.FirstName = _.get(account, 'patient.firstName', '');
			documentData.LastName = _.get(account, 'patient.lastName', '');
			documentData.Contact_First_Name = _.get(account, 'patient.contact[0].firstName', '');
			documentData.Contact_Last_Name = _.get(account, 'patient.contact[0].lastName', '');
			documentData.Contact_Type = _.get(account, 'patient.contact[0].type', '');
			account.patient.addresses.forEach((address, index) => {
				documentData[`Patient_Address_${index}_Line_1`] = _.get(account, `patient.addresses[${index}].address1`, '');
				documentData[`Patient_Address_${index}_Line_2`] = _.get(account, `patient.addresses[${index}].address2`, '');
				documentData[`Patient_Address_${index}_City`] = _.get(account, `patient.addresses[${index}].city`, '');
				documentData[`Patient_Address_${index}_State`] = _.get(account, `patient.addresses[${index}].state`, '');
				documentData[`Patient_Address_${index}_Zip`] = _.get(account, `patient.addresses[${index}].zip`, '');
				documentData[`Patient_Address_${index}_Country`] = _.get(account, `patient.addresses[${index}].country`, '');
			});
			documentData.Sex = _.get(account, 'patient.gender', '');
			documentData.DOB = _.get(account, 'patient.dateOfBirth', '');
			account.patient.phoneNumbers.forEach((phoneNumber, index) => {
				documentData[`Patient_Phone_Number_${index}`] = _.get(account, `patient.phoneNumbers[${index}].number`, '');
			});
			account.patient.emailAddresses.forEach((emailAddress, index) => {
				documentData[`Patient_Email_Address_${index}`] = _.get(account, `patient.emailAddresses[${index}].address`, '');
			});
			documentData.MemberNumber = _.get(this.dataService.session, 'memberNumber', '');

			documentData.CreateDate = now;

			const surveys: pme.Survey[] = this.dataService.enterprise.intakeLayout.surveys || [];

			for (let survey of surveys) {
				const surveyId = this.dataService.getEnvironmentId(survey.surveyId);

				for (let question of survey.surveyQuestions) {
					const questionId = this.dataService.getEnvironmentId(question.questionId);
					const text = question.questionText;
					const surveySession = account.getSurveySession(surveyId);
					const answers = surveySession.getSurveySessionAnswers(questionId) || [];
					let concatvalue = '';

					for (let answer of answers) {
						concatvalue += (answer.answerValue ? answer.answerValue : survey.getSurveyAnswer(answer.questionId, answer.answerId).answerValue) + '\n';
					}

					documentData[text] = concatvalue;
				}
			}

			return this.enterpriseService.documentService.createPdf(documentName, documentData, portalName);
		}

		/////////////////////
		// email functions //
		/////////////////////

		email_feedback(feedbackRequest: pme.FeedbackRequest): angular.IPromise<boolean> {
			const email = this.dataService.getDataValue('EmailTemplate', 'Email', 'Feedback');
			const firstName = this.dataService.getDataValue('EmailTemplate', 'FirstName', 'Feedback') || '';
			const lastName = this.dataService.getDataValue('EmailTemplate', 'LastName', 'Feedback') || '';
			const template = this.dataService.getDataValue('EmailTemplate', 'Template', 'Feedback');

			const emailRequest: pme.EmailRequest = {
				parameters: 'TYPE=' + encodeURI(feedbackRequest.type) + '&' +
					'SUBJECT=' + encodeURI(feedbackRequest.subject) + '&' +
					'BODY=' + encodeURI(feedbackRequest.body) + '&' +
					'CAN_CONTACT=' + encodeURI(feedbackRequest.canContact),
				recipientAddress: email,
				recipientFirstName: firstName,
				recipientLastName: lastName,
				senderAddress: feedbackRequest.email,
				senderName: feedbackRequest.name,
				templaterName: template
			};

			return this.enterpriseService.emailService.send(emailRequest);
		}

		////////////////////////////
		// intakeLayout functions //
		////////////////////////////

		intakeLayout_get(key: number | string = null): angular.IPromise<pme.IntakeLayout> {
			if (typeof key === 'string') {
				const json = this.dataService.getReferenceValue(key);
				const temp = angular.fromJson(json);
				const intakeLayout = new pme.IntakeLayout(temp);

				return this.$q.when(intakeLayout);
			}

			const programId = this.dataService.getProgramId();

			return this.enterpriseService.intakeService.getIntakeLayout(programId, key);
		}

		intakeLayout_layoutSection_get(intakeLayout: pme.IntakeLayout, name: string): angular.IPromise<pme.LayoutSection> {
			const layoutSection = intakeLayout.getLayoutSection(name);

			return this.$q.when(layoutSection);
		}

		intakeLayout_survey_populate(intakeLayout: pme.IntakeLayout): angular.IPromise<boolean> {
			const surveyPromises = [];

			intakeLayout.surveyIds.forEach((sid: number | string) => {
				const id = this.dataService.getEnvironmentId(sid);
				surveyPromises.push(this.enterpriseService.surveyService.get(id));
			});

			return this.$q.all(surveyPromises).then((surveys: pme.Survey[]) => {
				intakeLayout.surveys = surveys;
				return true;
			});
		}

		////////////////////////
		// location functions //
		////////////////////////

		location_states_get(key: string = null): angular.IPromise<pme.State[]> {
			if (key) {
				const json = this.dataService.getReferenceValue(key);
				const temp = angular.fromJson(json);
				const states: pme.State[] = [];

				for (const state of temp) {
					states.push(new pme.State(state));
				}

				return this.$q.when(states);
			}

			return this.enterpriseService.locationService.getStates();
		}

		//////////////////////
		// survey functions //
		//////////////////////

		survey_get(key: number | string): angular.IPromise<pme.Survey> {
			if (typeof key === 'string') {
				const json = this.dataService.getReferenceValue(key);
				const temp = angular.fromJson(json);
				const survey = new pme.Survey(temp);

				return this.$q.when(survey);
			}

			return this.enterpriseService.surveyService.get(key);
		}

		//////////////////////
		// toastr functions //
		//////////////////////

		addToastr(type: string, title: string, content: string, options: any = null) {
			this.toastrService.add(type, title, content, options);
		}

		clearLastToastr() {
			this.toastrService.removeLast();
		}

		clearAllToastr() {
			this.toastrService.clearAll();
		}

		////////////////////////////////
		// dom manipulation functions //
		////////////////////////////////

		color(hex: string, percent: number = 0): string {
			if (hex.charAt(0) !== '#') {
				hex = this.dataService.getDataValue('Reference', 'Id', hex, '#FFFFFF');
			}

			let r = parseInt(hex.substring(1, 3), 16);
			let g = parseInt(hex.substring(3, 5), 16);
			let b = parseInt(hex.substring(5, 7), 16);

			percent = Math.max(-1, Math.min(1, percent));

			if (percent <= 0) {
				r = r * (1 + percent);
				g = g * (1 + percent);
				b = b * (1 + percent);
			} else {
				r = r + ((255 - r) * percent);
				g = g + ((255 - g) * percent);
				b = b + ((255 - b) * percent);
			}

			let rh = '0' + Math.floor(r).toString(16);
			let gh = '0' + Math.floor(g).toString(16);
			let bh = '0' + Math.floor(b).toString(16);

			return "#" + rh.substr(-2, 2) + gh.substr(-2, 2) + bh.substr(-2, 2);
		}

		elementShow(id: string, show: boolean): void {
			if (show) {
				$(id).removeClass('hide');
			} else {
				$(id).addClass('hide');
			}
		}

		private handleError(error: any, methodName: string): ng.IPromise<any> {
			this.errorService.handleError(new Portico.Models.PorticoException(`[${methodName}]`, error));
			return this.$q.reject(error);
		}
	}
}